var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22464 1.2572C7.41521 1.06687 7.67353 0.959961 7.94287 0.959961C8.21221 0.959961 8.47054 1.06687 8.66111 1.2572L14.4205 7.01663C14.6109 7.2072 14.7178 7.46553 14.7178 7.73487C14.7178 8.00421 14.6109 8.26254 14.4205 8.4531L8.66111 14.2125C8.46848 14.3923 8.21357 14.4902 7.95014 14.4857C7.68671 14.4811 7.43534 14.3744 7.24903 14.1881C7.06273 14.0018 6.95606 13.7505 6.95151 13.487C6.94696 13.2236 7.04488 12.9687 7.22463 12.7761L11.2495 8.75124L1.16707 8.75124C0.897508 8.75124 0.638991 8.64416 0.448384 8.45355C0.257778 8.26295 0.150696 8.00443 0.150696 7.73487C0.150696 7.46531 0.257778 7.20679 0.448385 7.01619C0.638991 6.82558 0.897508 6.7185 1.16707 6.7185L11.2495 6.7185L7.22464 2.69367C7.0343 2.5031 6.92739 2.24478 6.92739 1.97544C6.92739 1.7061 7.0343 1.44777 7.22464 1.2572Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.742d6fa394fc5047c6d161a2c413552a.svg";
export { ForwardRef as ReactComponent };